import Vue from 'vue';

import { Initializer } from '../interfaces/general';

export default class LoadingScreenInitializer implements Initializer {
  public mount($: JQueryStatic, app: Vue) {
    $("body").addClass("ready");
  }

  public unmount() {
    // nope
  }
}
